/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrTextHeaderModule } from './igr-text-header-module';
import { IgrSectionHeaderModule } from './igr-section-header-module';
import { IgrRowSeparatorModule } from './igr-row-separator-module';
import { IgrHeaderSeparatorModule } from './igr-header-separator-module';
import { IgrColumnResizingSeparatorModule } from './igr-column-resizing-separator-module';
import { IgrColumnMovingSeparatorModule } from './igr-column-moving-separator-module';
import { IgrSummaryRowRootModule } from './igr-summary-row-root-module';
import { IgrSummaryRowSectionModule } from './igr-summary-row-section-module';
import { IgrColumnWidthModule } from './igr-column-width-module';
import { IgrColumnSortDescriptionModule } from './igr-column-sort-description-module';
import { IgrColumnGroupDescriptionModule } from './igr-column-group-description-module';
import { IgrColumnSummaryDescriptionModule } from './igr-column-summary-description-module';
import { IgrLocalDataSourceModule } from "igniteui-react-core";
import { IgrDataGrid } from './igr-data-grid';
import { TypeRegistrar } from "igniteui-react-core";
var IgrDataGridCoreModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrDataGridCoreModule() {
    }
    IgrDataGridCoreModule.register = function () {
        IgrTextHeaderModule.register();
        IgrSectionHeaderModule.register();
        IgrRowSeparatorModule.register();
        IgrHeaderSeparatorModule.register();
        IgrColumnResizingSeparatorModule.register();
        IgrColumnMovingSeparatorModule.register();
        IgrSummaryRowRootModule.register();
        IgrSummaryRowSectionModule.register();
        IgrColumnWidthModule.register();
        IgrColumnSortDescriptionModule.register();
        IgrColumnGroupDescriptionModule.register();
        IgrColumnSummaryDescriptionModule.register();
        IgrLocalDataSourceModule.register();
        TypeRegistrar.registerCons('IgrDataGrid', IgrDataGrid);
    };
    return IgrDataGridCoreModule;
}());
export { IgrDataGridCoreModule };
//# sourceMappingURL=igr-data-grid-core-module.js.map
